export function assertNever(x: never, message: string): never {
  throw new Error(`${message}`);
}

export function delay(milliseconds: number): Promise<void> {
  return new Promise<void>((resolve) => {
    setTimeout(resolve, milliseconds);
  });
}

export function createDimensionsMap<T extends string | number, D>(
  enumType: Record<string, T>,
  dimensionMappingFn: (value: T) => D,
): Record<T, D> {
  return Object.values(enumType).reduce(
    (acc, value) => {
      acc[value] = dimensionMappingFn(value);
      return acc;
    },
    {} as Record<T, D>,
  );
}
